/*
* 我的票据业务 0917 zlh
*
*/

import ajax from './ajax'; // 引用二次封装ajax.js
export default {

  // 获取列表数据
  getFrontVoucherInfoList (params) {
    return ajax.get('loanform/blitem/blLoanAccountVoucherInfo/getFrontVoucherInfoList.ht', params);
  },
  // 进入添加凭证页面
  addFrontVoucherInfoPage (params) {
    return ajax.get('loanform/blitem/blLoanAccountVoucherInfo/addFrontVoucherInfoPage.ht', params);
  },
  // 删除接口
  delVoucherInfo (params) {
    return ajax.get('loanform/blitem/blLoanAccountVoucherInfo/delVoucherInfo.ht', params);
  },
  // 添加数据接口
  saveFrontVoucherInfo (params) {
    return ajax.get('loanform/blitem/blLoanAccountVoucherInfo/saveFrontVoucherInfo.ht', params);
  },
  // 详情接口
  getFrontVoucherInfoDetails (params) {
    return ajax.get('loanform/blitem/blLoanAccountVoucherInfo/getFrontVoucherInfoDetails.ht', params);
  },
  // 获取tab数据字典
  getByNodeKeyPC (params) {
    return ajax.get('/platform/system/getFromSysDic/getByNodeKeyPC.ht', params);
  },
  //ocr导入提交
  importOcr:function(params){
    return ajax.postForm('/loanform/blitem/blLoanAccountVoucherInfo/batchInvoiceOcrFront.ht',params)
  },
  //补充发票
  replenishVoucherInfoFront:function(params){
    return ajax.postForm('/loanform/blitem/blLoanAccountVoucherInfo/replenishVoucherInfoFront.ht',params);
  }

};



// WEBPACK FOOTER //
// ./src/api/myBill.js